export const environment = {
  type: 'production',
  production: true,
  resetProjectExplorerOnRefresh: false,
  apiUrl: 'https://application.videck.com/api',
  /** Switch back to the old module-specific theming (tab + top-menu colors and top-menu active highlight). Off by default. */
  enableModuleColors: false,
  /** Sales/support mailbox shown on public pages (buy-now volume licenses); same as the API's Email:ReplyToAddress. */
  contactEmail: 'info@videck.com',
  keycloak: {
    url: 'https://keycloak.videck.com/',
    realm: 'Videck',
    clientId: 'front-end',
  },
};
